import OrderIcon from 'assets/icon/order.svg';
import pdfIcon from 'assets/icon/pdf-blue.svg';
import PrinterIcon from 'assets/icon/printer.svg';
import ExcelIcon from 'assets/icon/xlsx.svg';
import Button from 'components/Button';
import { Actions, AppBarStyled, Header, Title } from 'components/CustomHeader/styled-components';
import ThemeButton from 'components/ThemeButton';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';

const MainButton = styled(ThemeButton)`
  && {
    margin: 0 0.5rem;
    height: 40px;
  }
`;

const SecondaryButton = styled(ThemeButton)`
  && {
    margin: 0 0.5rem;
    height: 40px;
  }
`;

interface Props {
  title: string;
  mainButtonText?: string;
  disableMainButton?: boolean;
  disableExport?: boolean;
  disablePrint?: boolean;
  hideMainButton?: boolean;
  handleClickMainButton?: () => void;
  children?: ReactNode;
  handleOrder?: () => void;
  handlePrint?: () => void;
  handleExport?: () => void;
  handlePdf?: () => void;
  showSecondaryButton?: boolean;
  handleClickSecondaryButton?: () => void;
  secondaryButtonText?: string;
  disableSecondaryButton?: boolean;
}

const ListHeader = ({
  title,
  disableMainButton = false,
  disableExport = false,
  disablePrint = false,
  hideMainButton = false,
  mainButtonText,
  handleClickMainButton,
  children,
  handleOrder,
  handlePrint,
  handleExport,
  handlePdf,
  showSecondaryButton = false,
  handleClickSecondaryButton,
  secondaryButtonText,
  disableSecondaryButton,
}: Props) => {
  const { t } = useTranslation();

  return (
    <AppBarStyled position="sticky" color="inherit">
      <Header data-test-id="list-header">
        <Title>{title}</Title>
        <Actions>
          {children}
          {handleOrder ? (
            <Button
              data-test-id="list-header-order-button"
              $isIcon={true}
              $isBackgroundless={true}
              padding={'0'}
              onClick={handleOrder}
              style={{ marginLeft: '0.4rem' }}
            >
              <span className="svg-icon-md">
                <SVG src={OrderIcon} style={{ width: '60px', height: '60px' }} />
              </span>
            </Button>
          ) : null}
          {!hideMainButton ? (
            <MainButton
              disabled={disableMainButton}
              onClick={handleClickMainButton}
              data-test-id="list-header-main-button"
            >
              {mainButtonText ?? t('lists_actualize')}
            </MainButton>
          ) : null}
          {showSecondaryButton ? (
            <SecondaryButton
              disabled={disableSecondaryButton}
              onClick={handleClickSecondaryButton}
              data-test-id="list-header-main-button"
            >
              {secondaryButtonText}
            </SecondaryButton>
          ) : null}
          {handleExport ? (
            <Button
              data-test-id="list-header-export-button"
              $isIcon={true}
              padding={'0'}
              onClick={handleExport}
              disabled={disableExport}
              style={handlePrint ? { marginRight: '0.5rem' } : undefined}
            >
              <span className="svg-icon-md">
                <SVG src={ExcelIcon} />
              </span>
            </Button>
          ) : null}
          {handlePrint ? (
            <Button
              data-test-id="list-header-print-button"
              $isIcon={true}
              padding={'0'}
              onClick={handlePrint}
              disabled={disablePrint}
            >
              <span className="svg-icon-md">
                <SVG src={PrinterIcon} />
              </span>
            </Button>
          ) : null}
          {handlePdf ? (
            <Button
              data-test-id="list-header-print-button"
              $isIcon={true}
              padding={'0'}
              onClick={handlePdf}
            >
              <span className="svg-icon-md">
                <SVG src={pdfIcon} />
              </span>
            </Button>
          ) : null}
        </Actions>
      </Header>
    </AppBarStyled>
  );
};

export default ListHeader;
